import React from 'react'
import get from 'lodash/get'

import { Button } from 'src/chrome'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'
import tileStyles from 'src/chrome/styles/detailView.module.scss'
import styles from './giftNoCard.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

type GiftNoCardProps = {
  order: OrderWithPartialLines
  handleAddCard: () => void
}

const GiftNoCard: React.FC<GiftNoCardProps> = props => {
  const { order, handleAddCard } = props
  const gift = get(order, 'lines[0].giftVariation')
  const imageUrl = gift ? gift.imageUrls[0] || gift.defaultImageUrl : ''
  return (
    <section
      className={`${tileStyles.previewSection} ${tileStyles.overviewCard}`}
      style={{ marginTop: 15, justifyContent: 'left' }}
    >
      <div className={styles.container}>
        <div className={styles.giftContainer}>
          <div>
            <Text type="body" color="primaryHeading">
              Gift
            </Text>
            <img className={styles.gift} src={imageUrl} alt={'Gift'} />
          </div>
          <div className={styles.giftActions}>
            <Text type="body" alignment="center" color="primaryHeading">
              That's a great gift, let's add a card to make it more meaningful.
            </Text>
            <Button
              id={'add_card_to_gift_btn'}
              title={'Add Card To Gift!'}
              style={{ marginTop: 60 }}
              onClick={handleAddCard}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default GiftNoCard
